<template>
    <div class="home">
        <!-- 顶部身份详情 -->
        <div class="person_identity">

            <!-- 家长老师双身份 -->
            <div class="identity-display"
                v-if="userInfo.personType == 13 && userInfo.id && userInfo.patriarchSchoolId && userInfo.patriarchUserId && nowTeacherIdentity && nowParentIdentity">
                <div class="top" @click="handleClickChangeTeacher">
                    <span class="title">{{ nowTeacherIdentity.schoolName || '' }}</span>
                    <span class="info">{{ nowTeacherIdentity.deptName || '' }} {{ nowTeacherIdentity.userName || ''
                        }}</span>
                    <van-icon v-if="teacherList.length > 1" name="arrow-down" size="14" style="margin-left: 5px;" />
                </div>
                <div class="bottom"  @click="handleClickChangeParent">
                    <span class="title">{{ nowParentIdentity.schoolName || '' }}</span>
                    <span  class="info">{{ nowParentIdentity.userName || '' }}</span>
                    <van-icon  v-if="parentList.length > 1" name="arrow-down" size="14" style="margin-left: 5px;" />

                </div>
            </div>


            <!-- 老师   -->
            <div class="identity-display" v-if="!nowParentIdentity && nowTeacherIdentity">
                <div class="top">
                    <span class="title">{{ nowTeacherIdentity.schoolName || '' }}</span>
                </div>
                <div class="bottom" @click="handleClickChangeTeacher">
                    <span class="info">{{ nowTeacherIdentity.deptName || '' }} {{ nowTeacherIdentity.userName ||
                    '' }}</span>
                    <van-icon v-if="teacherList.length > 1" name="arrow-down" size="14" style="margin-left: 5px;" />
                </div>
            </div>


            <!-- 学生 -->
            <div class="identity-display" v-if="nowParentIdentity && !nowTeacherIdentity">
                <div class="top">
                    <span class="title">{{ nowParentIdentity.schoolName || '' }}</span>
                </div>
                <div class="bottom"  @click="handleClickChangeParent">
                    <span class="info">{{ nowParentIdentity.deptName || '' }} {{ nowParentIdentity.userName || '' }}</span>
                    <van-icon v-if="parentList.length > 1" name="arrow-down" size="14" style="margin-left: 5px;" />
                </div>
            </div>


            <!-- 访客身份 -->
            <div class="identity-display" v-if="userInfo.personType == 2 && userInfo.mobile">
                <div class="top">
                    <span class="title">幼高专校园安全大脑平台</span>
                </div>
                <div class="bottom">
                    <span class="info">{{ userInfo.name }}</span>
                </div>
            </div>

            <!-- 未绑定身份  -->
            <div class="identity-display"
                v-if="!nowParentIdentity && !nowTeacherIdentity && userInfo.personType == 2 && !userInfo.mobile">
                <div class="top">
                    <span class="title">幼高专校园安全大脑平台</span>
                </div>
                <div class="bottom">
                    <wx-open-launch-weapp id="jump_btn" :path="path" username="gh_821f740b866d">
                        <script type="text/wxtag-template">
                            <style>
                                .info {
                                    font-family: Source Han Sans CN, Source Han Sans CN;
                                    font-weight: 400;
                                    color:#fff;
                                    font-size: .875rem;
                                    line-height: .875rem;
                                }
                            </style>
                            <span class="info">暂无身份信息，去绑定 </span>
                        </script>
                    </wx-open-launch-weapp>
                    <van-icon size=".875rem" name="arrow" />
                </div>
            </div>
            <img class="bg" :src="bg" alt="">
        </div>
        <div class="app_function">
            <!-- 基础功能 -->
            <div class="basic">
                <!-- 老师基础功能 -->

                <div class="teacher_basic_left" v-if="userInfo.personType == 13 && userInfo.id && nowTeacherIdentity">


                    <div class="left_basic">
                        <!-- <div class="basic_title">
                            <span class="title_text">报警处置</span>
                            <img class="title_img" :src="clickRight" alt="">
                        </div>
                        <span class="title_info">预报警事件处理</span> -->



                        <!-- 报警小程序跳转 -->
                        <wx-open-launch-weapp id="jump_btn" username="gh_413729c33f2a">
                            <script type="text/wxtag-template">
                                <style>
                                    .basic_title {
                                        display: flex;
                                        align-items: center;
                                        margin-bottom: .75rem;
                                    }
                                    .title_text {
                                            font-family: Source Han Sans CN, Source Han Sans CN;
                                            font-weight: bold;
                                            font-size: 1.125rem;
                                            line-height: 1.125rem;
                                            height: 1.125rem;
                                            display:block;
                                            color: #333333;
                                            margin-right: .5rem;
                                    }

                                    .title_img {
                                        width: 1rem;
                                        margin: auto 0;
                                        height: 1rem;
                                    }

                                    .title_info {
                                        font-family: Source Han Sans CN, Source Han Sans CN;
                                        font-weight: 400;
                                        font-size: .75rem;
                                        line-height: .75rem;
                                        color: #333333;
                                    }
                                </style>
                                <div class="basic_title">
                                    <span class="title_text">报警处置</span>
                                    <img class="title_img" src="http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/ab5251fa-2f5b-4089-afbf-78616a4b7a2e.png" alt="">
                                </div>
                                <span class="title_info">预报警事件处理</span>
                            </script>
                        </wx-open-launch-weapp>
                    </div>
                </div>






                <div class="teacher_basic_right" v-if="userInfo.personType == 13 && userInfo.id && nowTeacherIdentity"
                    @click="$router.push(`/approval?appId=${appId}`);">
                    <div class="right_basic">
                        <div class="basic_title">
                            <span class="title_text">我去审批</span>
                            <img class="title_img" :src="clickRight" alt="">
                        </div>
                        <span class="title_info">学生请假等审批</span>
                    </div>
                </div>



                <!-- 家长基础功能 -->
                <!-- <div class="parent_basic_left" v-if="!nowTeacherIdentity && nowParentIdentity"
                    @click="$router.push(`/studentAttendance?appId=${appId}`);">
                    <div class="left_basic">
                        <div class="basic_title">
                            <span class="title_text">孩子出勤</span>
                            <img class="title_img" :src="clickRight" alt="">
                        </div>
                        <span class="title_info">孩子出勤详情</span>
                    </div>
                </div>
                <div class="parent_basic_right" v-if="!nowTeacherIdentity && nowParentIdentity"
                    @click="$router.push(`/leaveForm?appId=${appId}`);">
                    <div class="right_basic">
                        <div class="basic_title">
                            <span class="title_text">孩子请假</span>
                            <img class="title_img" :src="clickRight" alt="">
                        </div>
                        <span class="title_info">给孩子请假</span>
                    </div>
                </div> -->
            </div>
            <!-- 消息通知 -->
            <!-- <div class="notice"></div> -->
            <!-- 应用列表 -->
            <div class="application_list">
                <div class="application_item" v-if="teacherMenuList.length > 0">
                    <div class="title">
                        <span class="title_text">老师应用</span>
                    </div>
                    <div class="app_list">



                        <div class="app_item"
                            v-for="item in teacherMenuList"
                            @click="handleClickJumpRoute(item)" :key="item.path">
                            
                            <template v-if="item.path == '/teacherWxInfo'">
                                <wx-open-launch-weapp id="jump_btn" :path="teacherWxUrl" username="gh_821f740b866d">
                                    <script type="text/wxtag-template">
                                        <style>
                                    
                                            .title_img {
                                                width: 2.375rem;
                                                height: 2.375rem;
                                                display:block;
                                                background-color: #3167F6;
                                                margin: 0 auto;
                                                margin-bottom: .8125rem;

                                                border-radius: .3125rem;
                                            }
                                            .title_info {
                                                font-family: Source Han Sans CN, Source Han Sans CN;
                                                font-weight: 400;
                                                display:block;
                                                font-size: .9063rem;
                                                color: #333333;
                                            }
                                        </style>
                                    
                                        <img class="title_img" src="http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/d08662ce-e3e5-443e-8b86-f81d81133394.png" alt="">
                                        <span class="title_info">老师信息采集</span>
                                    </script>
                                </wx-open-launch-weapp>
                            </template>

                            <template v-if="item.path == '/violationReporting'">
                                <wx-open-launch-weapp id="jump_btn" username="gh_cd69886dd95b">
                                    <script type="text/wxtag-template">
                                        <style>

                                            .title_img {
                                                width: 2.375rem;
                                                height: 2.375rem;
                                                display:block;
                                                background-color: #3167F6;
                                                margin: 0 auto;
                                                margin-bottom: .8125rem;

                                                border-radius: .3125rem;
                                            }
                                            .title_info {
                                                font-family: Source Han Sans CN, Source Han Sans CN;
                                                font-weight: 400;
                                                display:block;
                                                font-size: .9063rem;
                                                color: #333333;
                                            }
                                        </style>
                                    
                                        <img class="title_img" src="http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/d342846d-a364-4272-9fa0-3599b07d1c3b.png" alt="">
                                        <span class="title_info">学生违纪上报</span>
                                    </script>
                                </wx-open-launch-weapp>
                            </template>

                            <template v-if="item.path != '/teacherWxInfo' && item.path != '/violationReporting'">
                                <div class="icon_div">
                                    <i :class="`iconfont  ${item.meta.icon}`" />
                                </div>
                                <span>{{ item.meta.title }}</span>
                            </template>
                        </div>



                        <!-- 违纪上报 -->
                        <!-- <div class="app_item"
                            v-if="teacherMenuList.map(item => item.path).includes('/violationReporting')">

                        </div>

                        <div class="app_item" v-if="teacherMenuList.map(item => item.path).includes('/teacherWxInfo')">

                        </div> -->

                    </div>
                </div>

                <div class="application_item" v-if="parentMenuList.length > 0">
                    <div class="title">
                        <span class="title_text">学生应用</span>
                    </div>
                    <div class="app_list">




                        <div class="app_item" v-for="item in parentMenuList"
                            :key="item.path" @click="handleClickJumpRoute(item)">

                            <template v-if="item.path == '/studentWxInfo'">
                                <wx-open-launch-weapp id="jump_btn" :path="parentWxUrl" username="gh_821f740b866d">
                                    <script type="text/wxtag-template">
                                        <style>
                                    
                                            .title_img {
                                                width: 2.375rem;
                                                height: 2.375rem;
                                                display:block;
                                                background-color: #3167F6;
                                                margin: 0 auto;
                                                margin-bottom: .8125rem;
                                                border-radius: .3125rem;
                                            }
                                            .title_info {
                                                font-family: Source Han Sans CN, Source Han Sans CN;
                                                font-weight: 400;
                                                display:block;
                                                text-align: center;
                                                font-size: .875rem;
                                                color: #333333;
                                            }
                                        </style>
                                    
                                        <img class="title_img" src="http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/d342846d-a364-4272-9fa0-3599b07d1c3b.png" alt="">
                                        <span class="title_info">学生信息采集</span>
                                    </script>
                                </wx-open-launch-weapp>
                            </template>

                            <template v-else>
                                <div class="icon_div">
                                    <i :class="`iconfont  ${item.meta.icon}`" />
                                </div>
                                <span>{{ item.meta.title }}</span>
                            </template>






                        </div>



                        <!-- 添加人员录入 -->

                        <!-- <div class="app_item" v-if="parentMenuList.map(item => item.path).includes('/studentWxInfo')">
                           
                        </div> -->
                    </div>
                </div>

                <div class="application_item">
                    <div class="title">
                        <span class="title_text">个人中心</span>
                    </div>
                    <div class="app_list">
                        <div class="app_item" @click="$router.push(`/profile2?appId=${appId}`);">
                            <div class="icon_div">
                                <i :class="`iconfont icon-gerenxinxi`" />
                            </div>
                            <span>个人信息</span>
                        </div>

                        <div class="app_item" @click="$router.push(`/notice-setting?appId=${appId}`);">
                            <div class="icon_div">
                                <i :class="`iconfont icon-xiaoxishezhi`" />
                            </div>
                            <span>消息设置</span>
                        </div>

                        <div class="app_item" @click="$router.push(`/schoolList?appId=${appId}`);">
                            <div class="icon_div">
                                <i :class="`iconfont icon-shenfenqiehuan`" />
                            </div>
                            <span>身份切换</span>
                        </div>

                        <!-- 访客专属 -->
                        <div class="app_item" v-if="userInfo.personType == 2 && userInfo.mobile"
                            @click="$router.push(`/visited-history?appId=${appId}`);">
                            <div class="icon_div">
                                <i :class="`iconfont icon-yuyue`" />
                            </div>
                            <span>我的预约</span>
                        </div>
                    </div>
                </div>

                <!-- 无身份显示图片  -->
                <div class="noPerson"
                    v-if="!nowParentIdentity && !nowTeacherIdentity && userInfo.personType == 2 && !userInfo.mobile">
                    <img :src="notShenfen" alt="">
                    <span class="tip">绑定身份信息 获取更多功能</span>

                    <wx-open-launch-weapp id="jump_btn" :path="path" username="gh_821f740b866d">
                        <script type="text/wxtag-template">
                            <style>
                                .bind {
                                    font-family: Source Han Sans CN, Source Han Sans CN;
                                    font-weight: 500;
                                    font-size: .875rem;
                                    display:block;
                                    width: 7.5rem;
                                    text-align: center;
                                    color: #3167F6;
                                    margin-top: .75rem;
                                }
                            </style>
                            <span class="bind">去绑定</span>
                        </script>
                    </wx-open-launch-weapp>

                </div>

            </div>
        </div>

        <!-- 老师身份选择 -->
        <van-popup v-model="teacherShowPicker" round position="bottom">
            <van-picker :default-index="defaultIndex" show-toolbar :columns="columns"
                @cancel="teacherShowPicker = false" @confirm="handleTeacherOnComfirm" />
        </van-popup>
        <!-- 家长身份选择 -->
        <van-popup v-model="parentShowPicker" round position="bottom">
            <van-picker :default-index="defaultIndex" show-toolbar :columns="columns" @cancel="parentShowPicker = false"
                @confirm="handleParentOnComfirm" />
        </van-popup>

    </div>
</template>
<script>
import testimg from '@/assets/img_test.png'
import bg from '@/assets/home_title_bg.png'

import store from "../../store";

import clickRight from '@/assets/click_right.png'
import notShenfen from '@/assets/notShenfen.png'
import bottom from '@/assets/changebottom.png'
export default {
    data() {
        return {
            testimg,
            bg,
            clickRight,
            notShenfen, bottom,
            teacherShowPicker: false,
            parentShowPicker: false,

            appId: localStorage.getItem('appId'),
            userInfo: JSON.parse(localStorage.getItem("userInfo")),

            nowParentIdentity: null,// 当前家长身份
            nowTeacherIdentity: null,// 当前老师身份

            teacherList: [], // 老师身份列表
            parentList: [],  // 家长身份列表


            teacherMenuList: [],// 老师菜单列表
            parentMenuList: [], // 家长菜单列表

            columns: [],
            defaultIndex: 0,


            teacherWxUrl: '', // 老师信息采集url
            parentWxUrl: '', // 家长信息采集url
            path: ''// 用户身份绑定路径
        }
    },

    created() {
        // 获取当前人员身份选择项
        this.getSchoolList()
    },

    mounted() {

        this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
    },
    methods: {
        initWXConfig() {
            this.$https
                .getWXConfig({
                    appid: store.state.appId,
                    url: location.href.split("#")[0],
                })
                .then((res) => {
                    console.log("拿到配置结果", res);

                    // 判断是否自动登录
                    if (res.code == 401) {
                        // if () {

                        // }
                    } else {
                        wx.config({
                            debug: false,
                            appId: res.data.appId,
                            timestamp: res.data.timestamp, //生成签名的时间戳
                            nonceStr: res.data.nonceStr,
                            signature: res.data.signature,
                            jsApiList: ["onMenuShareWeibo", "closeWindow"],
                            openTagList: ["wx-open-launch-weapp"],
                        });
                        wx.error(function (res) {
                            console.log("配置失败", res);
                        });
                        let loginId = JSON.parse(localStorage.getItem("userInfo")).loginId;
                        let openId = JSON.parse(localStorage.getItem("userInfo")).openId;
                        let token = localStorage.getItem("token");


                        console.log('this.nowTeacherIdentity', this.nowTeacherIdentity)
                        this.path = `pages/authPhone/indelx/indelx?loginId=${loginId}&openId=${openId}&token=${token}`;
                        
                        this.teacherWxUrl = this.nowTeacherIdentity ?  `pages/login/login?schoolName=${this.nowTeacherIdentity.schoolName}&userId=${this.nowTeacherIdentity.schoolId}&status=2&schoolId=${this.nowTeacherIdentity.schoolId}` : ''
                        this.parentWxUrl = this.nowParentIdentity ? `pages/login/login?schoolName=${this.nowParentIdentity.schoolName}&userId=${this.nowParentIdentity.schoolId}&groupId=2&status=1` : ''


                    }

                });
        },
        // 获取当前人员身份列表
        async getSchoolList() {
            const { code, data, msg } = await this.$https.getSchoolList()
            if (code != 200) {
                this.$toast(msg)
                return
            }
            let obj = { 13: "老师", 12: "家长", 2: "访客",11: '学生' }
            this.teacherList = data.teacherList && data.teacherList.map(item => {
                item.position = obj[item.personType]
                return item
            })
            this.parentList = data.studentList && data.studentList.map(item => {
                item.position = obj[item.personType]
                return item
            })

            this.getTeacherOrParentIdentity()

        },

        getTeacherOrParentIdentity() {
            // 判断当前人员的身份

            if (this.userInfo.id && this.userInfo.personType == 13) {
                let obj = this.teacherList.find(item => item.id == this.userInfo.id)
                this.nowTeacherIdentity = obj
            }

            if (this.userInfo.patriarchSchoolId && this.userInfo.patriarchUserId) {
                let obj = this.parentList.find(item => item.id == this.userInfo.patriarchUserId)
                this.nowParentIdentity = obj
            }
            this.initWXConfig();
            this.getPermissionMenu()
        },


        // 根据权限获取权限菜单
        async getPermissionMenu() {
            let userInfo = JSON.parse(localStorage.getItem("userInfo"))

            if (userInfo.id && userInfo.personType == 13 && userInfo.patriarchUserId && userInfo.patriarchSchoolId && this.nowTeacherIdentity && this.nowParentIdentity) { // 获取双身份菜单


                const teachRes = await this.$https.getTeachMenuList({ schoolId: JSON.parse(localStorage.getItem("userInfo")).schoolId })
                const parentRes = await this.$https.getParentMenuList({ schoolId: JSON.parse(localStorage.getItem("userInfo")).patriarchSchoolId })
                if (teachRes.code == 200) {
                    this.teacherMenuList = teachRes.data ? teachRes.data : []
                    // 更新本地存储
                    let arr = teachRes.data ? teachRes.data.map(item => item.path) : []
                    localStorage.setItem("teachUrls", JSON.stringify(arr));
                }

                if (parentRes.code == 200) {
                    this.parentMenuList = parentRes.data ? parentRes.data : []
                    let arr = parentRes.data ? parentRes.data.map(item => item.path) : []
                    // 更新本地存储
                    localStorage.setItem("parentUrls", JSON.stringify(arr));
                }

            } else if (userInfo.id && userInfo.personType == 13 && !userInfo.patriarchUserId && !userInfo.patriarchSchoolId && this.nowTeacherIdentity) { //获取老师身份菜单
                const teachRes = await this.$https.getTeachMenuList({ schoolId: JSON.parse(localStorage.getItem("userInfo")).schoolId })
                if (teachRes.code == 200) {
                    this.teacherMenuList = teachRes.data ? teachRes.data : []
                    let arr = teachRes.data ? teachRes.data.map(item => item.path) : []
                    localStorage.setItem("teachUrls", JSON.stringify(arr));
                }
            } else if (this.nowParentIdentity) { // 获取家长身份菜单
                const parentRes = await this.$https.getParentMenuList({ schoolId: JSON.parse(localStorage.getItem("userInfo")).patriarchSchoolId })
                if (parentRes.code == 200) {
                    this.parentMenuList = parentRes.data ? parentRes.data : []
                    let arr = parentRes.data ? parentRes.data.map(item => item.path) : []
                    // 更新本地存储
                    localStorage.setItem("parentUrls", JSON.stringify(arr));
                }
            }
        },

        // 老师身份切换
        async handleTeacherOnComfirm(picker, value, index) {
            console.log('picker,value,index', picker, value, index)
            if (picker.id == this.nowTeacherIdentity.id) {
                this.teacherShowPicker = false
            } else {
                this.teacherShowPicker = false

                // 切换身份 
                const { data, code } = await this.$https.identitySwitch({
                    openId: this.userInfo.openId,
                    userId: picker.id,
                    userType: '1'
                })
                if (this.nowParentIdentity) {
                    const { data, code: code1 } = await this.$https.identitySwitch({
                        openId: this.userInfo.openId,
                        userId: this.nowParentIdentity.id,
                        userType: '2'
                    })
                    if (code != 200 && code1 != 200) {
                        return
                    }
                    this.$toast('切换成功')

                    this.nowTeacherIdentity = picker
                    this.teacherWxUrl = `pages/login/login?schoolName=${this.nowTeacherIdentity.schoolName}&userId=${this.nowTeacherIdentity.schoolId}&status=2&schoolId=${this.nowTeacherIdentity.schoolId}`
                    this.$store.commit("setUserId", data.id);
                    this.$store.commit("setSchoolId", data.schoolId);
                    localStorage.setItem("userInfo", JSON.stringify(data));
                    this.userInfo = data
                    // 更新权限
                    this.getPermissionMenu()
                } else {
                    if (code != 200) {
                        return
                    }
                    this.$toast('切换成功')
                    this.nowTeacherIdentity = picker
                    this.teacherWxUrl = `pages/login/login?schoolName=${this.nowTeacherIdentity.schoolName}&userId=${this.nowTeacherIdentity.schoolId}&status=2&schoolId=${this.nowTeacherIdentity.schoolId}`
                    this.$store.commit("setUserId", data.id);
                    this.$store.commit("setSchoolId", data.schoolId);
                    localStorage.setItem("userInfo", JSON.stringify(data));
                    this.userInfo = data
                    // 更新权限
                    this.getPermissionMenu()
                }

            }
        },
        // 家长身份切换
        async handleParentOnComfirm(picker, value, index) {
            console.log('picker,value,index', picker, value, index)
            if (picker.id == this.nowParentIdentity.id) {
                this.parentShowPicker = false
            } else {
                this.parentShowPicker = false

                // 切换身份 
                const { data, code } = await this.$https.identitySwitch({
                    openId: this.userInfo.openId,
                    userId: picker.id,
                    userType: '2'
                })
                if (this.nowTeacherIdentity) {
                    const { data, code: code1 } = await this.$https.identitySwitch({
                        openId: this.userInfo.openId,
                        userId: this.nowTeacherIdentity.id,
                        userType: '1'
                    })
                    if (code != 200 && code1 != 200) {
                        return
                    }
                    this.$toast('切换成功')
                    console.log('data1', data)
                    this.nowParentIdentity = picker
                    this.parentWxUrl = `pages/login/login?schoolName=${this.nowParentIdentity.schoolName}&userId=${this.nowParentIdentity.schoolId}&groupId=2&status=1`
                    this.$store.commit("setUserId", data.id);
                    this.$store.commit("setSchoolId", data.schoolId);
                    localStorage.setItem("userInfo", JSON.stringify(data));
                    this.userInfo = data
                    // 更新权限
                    this.getPermissionMenu()

                } else {
                    if (code != 200) {
                        return
                    }
                    this.$toast('切换成功')
                    this.nowParentIdentity = picker
                    this.parentWxUrl = `pages/login/login?schoolName=${this.nowParentIdentity.schoolName}&userId=${this.nowParentIdentity.schoolId}&groupId=2&status=1`
                    localStorage.setItem("userInfo", JSON.stringify(data));
                    this.userInfo = data
                    this.getPermissionMenu()
                }


            }
        },


        handleClickChangeTeacher() {
            let obj = this.teacherList
            if (obj.length > 1) {
                obj.forEach(item => item.text = `${item.schoolName} - ${item.deptName} ${item.userName}`)
                // 获取当前选中的索引
                let index = this.teacherList.findIndex(item => item.id == this.nowTeacherIdentity.id)
                this.defaultIndex = index
                this.columns = obj
                this.teacherShowPicker = true
            }

        },

        handleClickChangeParent() {
            console.log('123456')
            let obj = this.parentList
            if (obj.length > 1) {
                obj.forEach(item => item.text = `${item.schoolName} ${item.userName}`)
                let index = this.parentList.findIndex(item => item.id == this.nowParentIdentity.id)
                this.defaultIndex = index
                this.columns = obj
                this.parentShowPicker = true
            }

        },

        // 跳转路由
        handleClickJumpRoute(data) {
            let appId = localStorage.getItem("appId")
            if (data.path == '/subscribe') {
                this.$router.push(`${data.path}?appId=${appId}&schoolId=${this.userInfo.schoolId}`);
            } else if (data.path == '/parentUsageGuide') { // 家长使用指南
                window.location.href = "https://mp.weixin.qq.com/s/2DDpKDHeeBvkntjn3pTWaA"
            } else if (data.path == '/teacherUsageGuide') { // 老师使用指南
                window.location.href = "https://mp.weixin.qq.com/s/EJXjNSjY1rdZHJtfFtOPlQ"
            } else {
                this.$router.push(`${data.path}?appId=${appId}`);
            }
        },

    }
}
</script>
<style scoped lang="scss">
.home {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background-color: #3167F6;
    flex-direction: column;
    display: flex;

    .person_identity {
        height: 5.5625rem;
        width: 100%;
        position: relative;
        padding: 0 .875rem;

        color: #fff;

        overflow: hidden;

        .identity-display {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            height: 100%;
            position: relative;
            z-index: 2;

            .top {
                .title {
                    font-weight: 500;
                    font-family: Source Han Sans CN, Source Han Sans CN;
                    font-size: 1.125rem;
                    margin-right: .625rem;
                }

                .info {
                    font-family: Source Han Sans CN, Source Han Sans CN;
                    font-weight: 400;
                    font-size: .875rem;
                }

                .bottom_img {
                    width: .375rem;
                    height: .25rem;
                }
            }

            .bottom {
                position: relative;
                z-index: 1;
                .title {
                    font-weight: 500;
                    font-family: Source Han Sans CN, Source Han Sans CN;
                    font-size: 1.125rem;
                    margin-right: .625rem;
                }

                .info {
                    font-family: Source Han Sans CN, Source Han Sans CN;
                    font-weight: 400;
                    font-size: .875rem;
                    line-height: .875rem;
                }

                .bottom_img {
                    width: .375rem;
                    height: .25rem;
                }
            }

        }

        .bg {
            width: 7.875rem;
            height: 8.8125rem;
            position: absolute;
            top: 0;
            z-index: 0;
            right: .875rem;
        }
    }

    .app_function {
        flex: 1;
        width: 100%;
        // overflow-y: auto;
        background: linear-gradient(180deg, #D8E5FF 0%, #F2F4F7 100%);
        border-radius: 16px 16px 0px 0px;
        padding: .9375rem;

        .basic {
            // height: 5.9375rem;
            display: flex;
            justify-content: space-between;

            // 老师基础功能
            .teacher_basic_left {
                width: 50%;
                clip-path: polygon(0 0, 100% 0%, 92% 100%, 0% 100%);
                background: #fff url('../../assets/alarm.png') no-repeat center/cover;
                border-radius: .625rem;
                border-bottom-right-radius: 1.875rem;
                padding: 1.5625rem 0 1.0625rem .9375rem;

                .left_basic {
                    display: flex;
                    flex-direction: column;

                    .basic_title {
                        display: flex;
                        align-items: center;
                        margin-bottom: .75rem;

                        .title_text {
                            font-family: Source Han Sans CN, Source Han Sans CN;
                            font-weight: bold;
                            font-size: 1.125rem;
                            color: #333333;
                            margin-right: .5rem;
                        }

                        .title_img {
                            width: 1rem;
                            height: 1rem;
                        }
                    }

                    .title_info {
                        font-family: Source Han Sans CN, Source Han Sans CN;
                        font-weight: 400;
                        font-size: .75rem;
                        line-height: .75rem;
                        color: #333333;
                    }
                }



            }

            .teacher_basic_right {
                width: 50%;
                clip-path: polygon(8% 0%, 100% 0%, 100% 100%, 0% 100%);
                background: #fff url('../../assets/approve.png') no-repeat center/cover;
                border-radius: .625rem;
                border-top-left-radius: 1.875rem;
                padding: 1.5625rem 0 1.5625rem 1.375rem;

                .right_basic {
                    display: flex;
                    flex-direction: column;

                    .basic_title {
                        display: flex;
                        align-items: center;
                        margin-bottom: .75rem;

                        .title_text {
                            font-family: Source Han Sans CN, Source Han Sans CN;
                            font-weight: bold;
                            font-size: 1.125rem;
                            color: #333333;
                            margin-right: .5rem;
                        }

                        .title_img {
                            width: 1rem;
                            height: 1rem;
                        }
                    }

                    .title_info {
                        font-family: Source Han Sans CN, Source Han Sans CN;
                        font-weight: 400;
                        font-size: .75rem;
                        line-height: .75rem;
                        color: #333333;
                    }
                }
            }

            // 家长基础功能
            .parent_basic_left {
                width: 50%;
                clip-path: polygon(0 0, 100% 0%, 92% 100%, 0% 100%);
                background: #fff url('../../assets/childattendance.png') no-repeat center/cover;
                border-radius: .625rem;
                border-bottom-right-radius: 1.875rem;
                padding: 1.5625rem 0 1.0625rem .9375rem;

                .left_basic {
                    display: flex;
                    flex-direction: column;

                    .basic_title {
                        display: flex;
                        align-items: center;
                        margin-bottom: .75rem;

                        .title_text {
                            font-family: Source Han Sans CN, Source Han Sans CN;
                            font-weight: bold;
                            font-size: 1.125rem;
                            color: #333333;
                            margin-right: .5rem;
                        }

                        .title_img {
                            width: 1rem;
                            height: 1rem;
                        }
                    }

                    .title_info {
                        font-family: Source Han Sans CN, Source Han Sans CN;
                        font-weight: 400;
                        font-size: .75rem;
                        line-height: .75rem;
                        color: #333333;
                    }
                }
            }

            .parent_basic_right {
                width: 50%;
                clip-path: polygon(8% 0%, 100% 0%, 100% 100%, 0% 100%);
                background: #fff url('../../assets/childleave.png') no-repeat center/cover;
                border-radius: .625rem;
                border-top-left-radius: 1.875rem;
                padding: 1.5625rem 0 1.5625rem 1.375rem;

                .right_basic {
                    display: flex;
                    flex-direction: column;

                    .basic_title {
                        display: flex;
                        align-items: center;
                        margin-bottom: .75rem;

                        .title_text {
                            font-family: Source Han Sans CN, Source Han Sans CN;
                            font-weight: bold;
                            font-size: 1.125rem;
                            color: #333333;
                            margin-right: .5rem;
                        }

                        .title_img {
                            width: 1rem;
                            height: 1rem;
                        }
                    }

                    .title_info {
                        font-family: Source Han Sans CN, Source Han Sans CN;
                        font-weight: 400;
                        font-size: .75rem;
                        line-height: .75rem;
                        color: #333333;
                    }
                }
            }
        }

        .notice {
            margin-top: .75rem;
            height: 2.625rem;
            background-color: #fff;
            border-radius: .5rem;
        }

        .application_list {
            margin-top: 1.125rem;
            display: flex;
            flex-direction: column;
            width: 100%;

            .application_item {
                width: 100%;

                .title {
                    .title_text {
                        font-family: Source Han Sans CN, Source Han Sans CN;
                        font-weight: bold;
                        font-size: 1.125rem;
                        color: #333333;
                    }
                }

                .app_list {
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    margin-bottom: 1.875rem;

                    .app_item {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        width: 25%;
                        margin-top: 1.25rem;
                        // background-color: pink;

                        img {
                            width: 2.375rem;
                            height: 2.375rem;
                            background-color: #3167F6;
                            margin-bottom: .625rem;
                            border-radius: .3125rem;
                        }

                        // 图标容器
                        .icon_div {
                            width: 2.375rem;
                            height: 2.375rem;
                            background-color: #3167F6;
                            margin-bottom: .625rem;
                            text-align: center;
                            line-height: 2.375rem;
                            border-radius: .3125rem;

                            i {
                                color: #fff;
                                font-size: 1.5rem
                            }
                        }


                        span {
                            font-family: Source Han Sans CN, Source Han Sans CN;
                            font-weight: 400;
                            font-size: .875rem;
                            color: #333333;
                        }
                    }
                }
            }

            .noPerson {
                // background-color: red;
                display: flex;
                flex-direction: column;
                align-items: center;

                img {
                    width: 12.1875rem;
                    height: 11.75rem;
                    margin: 3.5rem auto 1.625rem;
                }

                .tip {
                    font-family: Source Han Sans CN, Source Han Sans CN;
                    font-weight: 400;
                    font-size: .875rem;
                    color: #999999;
                }

                .bind {
                    font-family: Source Han Sans CN, Source Han Sans CN;
                    font-weight: 500;
                    font-size: .875rem;
                    color: #3167F6;
                    margin-top: .75rem;
                }
            }
        }
    }
}
</style>